export enum FiltersDataHooks {
  ROOT = 'filters-root',
  CLEAR_FILTERS = 'clear-filters',
}
